import { alpha, Box, styled, Typography } from '@mui/material';

export const LeftIconBox = styled(Box)(({ theme }) => ({
    color: alpha(theme.palette.text.secondary, 0.67),
    fontSize: theme.typography.customFontSize.small,
    fontWeight: theme.typography.fontWeightMedium,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

    '& svg': {
        width: 16,
        height: 16,
        color: alpha(theme.palette.common.black, 0.7),
    },
}));
export const InfoListItemText = styled(Typography)(({ theme }) => ({
    color: alpha(theme.palette.text.secondary, 0.67),
    fontWeight: theme.typography.fontWeightMedium,
    cursor: 'pointer',
}));
